var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"vue-modal"},[_c('div',{staticClass:"outer"},[_vm._t("l1",[_c('div',{staticClass:"close"},[_c('div',{staticClass:"comment",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("x")])])]),_vm._v(" "),_vm._t("l2"),_vm._v(" "),_vm._t("l3"),_vm._v(" "),_vm._t("l4")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62af2898","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-modal.vue
// module id = null
// module chunks = 